import type { HTMLAttributes, ReactNode } from "react";

import * as styles from "./TrayColumns.styles";

interface Props extends HTMLAttributes<HTMLUListElement> {
  columnCount?: number;
  children: ReactNode;
}

const TrayColumns = ({ children, columnCount, ...rest }: Props) => (
  <ul css={[columnCount && styles.numberOfColumns(columnCount)]} {...rest}>
    {children}
  </ul>
);

export { TrayColumns };
